import { createReducer } from '../../lib/Utils'
import { GET_FEATURE_FLAG_FULFILLED } from './actions'

const initialState = {}

export default createReducer(initialState, {
  [GET_FEATURE_FLAG_FULFILLED]: (state, action) => {
    const feature_flags = { ...state.feature_flags }

    //Response keys are.. key / enabled.. are all feature flags this same format?
    feature_flags[action.payload.key] = action.payload.enabled

    const newState = { ...state, feature_flags }

    return newState
  },
})
